import { Button } from "@/components/ui/Button";
import {
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import { Input } from "@/components/ui/Input";
import { Label } from "@/components/ui/Label";
import { useAppContext } from "@/context/AppContext";
import { useLanguage } from "@/context/LanguageContext";
import { useMenuItemsContext } from "@/context/MenuItemsContext";

export function ChangeBillingInfo() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      title: "Změnit fakturační údaje",
      description: "Upravte své údaje níže.",
      userName: "Jméno",
      subject: "Název subjektu",
      idNumber: "IČ",
      idNumberTitle: "IČ musí mít přesně 8 číslic",
      address: "Adresa subjektu",
      cancelChanges: "Zrušit změny",
      saveChanges: "Uložit změny",
    },
    en: {
      title: "Change billing details",
      description: "Edit your details below.",
      userName: "Name",
      subject: "Business name",
      idNumber: "Company ID",
      idNumberTitle: "Company ID must contain exactly 8 digits",
      address: "Business address",
      cancelChanges: "Cancel changes",
      saveChanges: "Save changes",
    },
  }[language];
  const { isLoading, formData, setFormData, saveProfileInfo } = useAppContext();
  const { handleDiscardChanges } = useMenuItemsContext();

  return (
    <DialogContent className="sm:max-w-[425px]">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          saveProfileInfo();
        }}
        className="space-y-4"
      >
        <DialogHeader>
          <DialogTitle>{copy.title}</DialogTitle>
          <DialogDescription>{copy.description}</DialogDescription>
        </DialogHeader>

        <div className="grid gap-3 py-4">
          <div className="app-form-row">
            <Label htmlFor="userName" className="text-right">
              {copy.userName}
            </Label>
            <Input
              id="userName"
              name="userName"
              placeholder={copy.userName}
              className="col-span-3"
              value={formData.userName || ""}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  userName: e.target.value,
                })
              }
            />
          </div>

          <div className="app-form-row">
            <Label htmlFor="subject" className="text-right">
              {copy.subject}
            </Label>
            <Input
              id="subject"
              name="subject"
              placeholder={copy.subject}
              className="col-span-3"
              value={formData.subject || ""}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  subject: e.target.value,
                })
              }
            />
          </div>

          <div className="app-form-row">
            <Label htmlFor="idNumber" className="text-right">
              {copy.idNumber}
            </Label>
            <Input
              id="idNumber"
              name="idNumber"
              type="text"
              pattern="\d{8}"
              placeholder={formData.idNumber || copy.idNumber}
              title={copy.idNumberTitle}
              maxLength={8}
              required
              className="col-span-3"
              value={formData.idNumber || ""}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                setFormData({ ...formData, idNumber: value });
              }}
            />
          </div>

          <div className="app-form-row">
            <Label htmlFor="address" className="text-right">
              {copy.address}
            </Label>
            <Input
              id="address"
              name="address"
              placeholder={copy.address}
              className="col-span-3"
              value={formData.address || ""}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  address: e.target.value,
                })
              }
            />
          </div>

          <div className="flex justify-end pt-4"></div>
        </div>
        <DialogFooter className="flex flex-row justify-end items-center gap-3">
          <Button
            type="button"
            variant="outline"
            onClick={() => handleDiscardChanges()}
            className="ml-2"
          >
            {copy.cancelChanges}
          </Button>
          <Button
            type="submit"
            disabled={isLoading}
            variant={"default"}
            className="relative"
          >
            {isLoading ? (
              <>
                <span className="opacity-0">{copy.saveChanges}</span>
                <span className="dots">
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </span>
              </>
            ) : (
              copy.saveChanges
            )}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  );
}
